<template>
  <Toast />
  <ConfirmDialog />

  <ul class="list-none p-0 m-0 flex align-items-center font-medium mb-3">
    <li>
      <router-link to="/proforma" class="text-500 no-underline"
        >Proformas</router-link
      >
    </li>
    <li class="px-2">
      <i class="pi pi-angle-right text-500"></i>
    </li>
    <li>
      <span class="text-900">Editar Proforma #{{ proforma_id }}</span>
    </li>
  </ul>

  <div class="surface-section px-4 py-5">
    <div
      class="card mb-3 p-3"
      style="
        background: #ffffff;
        border: 1px solid #1e293b;
        border-radius: 8px;
        box-shadow: 0 2px 8px rgba(34, 211, 238, 0.15);
      "
    >
      <div
        class="flex justify-content-between align-items-center flex-wrap gap-3"
      >
        <div style="color: #1e293b; flex: 1; min-width: 280px">
          <h2
            class="m-0 mb-1"
            style="font-size: 1.5rem; font-weight: 700; line-height: 1.4"
          >
            <i class="pi pi-user mr-2" style="color: #06b6d4"></i>
            {{ clienteNombre }}
          </h2>
          <div
            class="flex align-items-center gap-3 flex-wrap"
            style="font-size: 1rem; font-weight: 600"
          >
            <span style="color: #64748b">
              <i class="pi pi-file mr-1" style="color: #06b6d4"></i>
              Proforma #{{ proforma_id }}
            </span>
            <span v-if="tipo_negocio == 2 && placa" style="color: #0891b2">
              <i class="pi pi-car mr-1" style="color: #06b6d4"></i>
              {{ placa }}
            </span>
          </div>
        </div>

        <div class="flex gap-2 flex-wrap" style="justify-content: flex-end">
          <Button
            label="CANCELAR"
            icon="pi pi-times"
            class="p-button-secondary p-button-lg"
            @click="goBack"
          />
          <Button
            label="GUARDAR"
            icon="pi pi-save"
            class="p-button-info p-button-lg"
            @click="guardarCambios"
            :loading="guardando"
            :disabled="productos.length === 0"
          />
          <Button
            label="CONVERTIR A VENTA"
            icon="pi pi-check"
            class="p-button-warning p-button-lg"
            @click="convertirAVenta"
            :disabled="productos.length === 0"
          />
        </div>
      </div>
    </div>

    <div class="card mb-3">
      <div class="p-fluid formgrid grid">
        <div class="field col-12 mb-0">
          <div class="p-inputgroup">
            <AutoComplete
              v-model="productoSelecionado"
              :suggestions="productosListadoFiltrado"
              @keyup.enter="buscarProducto($event)"
              @complete="manejadorBusquedaProducto($event)"
              placeholder="BUSCAR PRODUCTO/SERVICIO"
              class="w-full"
              :pt="{
                input: {
                  style:
                    'font-weight: 600; font-size: 1.05rem; padding: 0.75rem;',
                },
              }"
            >
              <template #header v-if="productosListadoFiltrado.length > 0">
                <div class="tabla-header">
                  <div class="th th-codigo" v-if="mostrar_codigo_interno">
                    CÓDIGO
                  </div>
                  <div class="th th-producto">PRODUCTO/SERVICIO</div>
                  <div class="th th-fabrica">MARCA</div>
                  <div class="th th-stock">STOCK</div>
                  <div class="th th-precio">PRECIO</div>
                </div>
              </template>

              <template #item="slotProps">
                <div class="tabla-fila">
                  <div class="td td-codigo" v-if="mostrar_codigo_interno">
                    {{ slotProps.item.codigo_interno }}
                  </div>
                  <div class="td td-producto">
                    {{ slotProps.item.descripcion }}
                  </div>
                  <div class="td td-fabrica">
                    {{ slotProps.item.fabrica_nombre }}
                  </div>
                  <div
                    class="td td-stock"
                    v-if="slotProps.item.tipo_catalogo == 1"
                  >
                    <span
                      :class="
                        stockClass(slotProps.item.stock[0]?.cantidad || 0)
                      "
                    >
                      {{ slotProps.item.stock[0]?.cantidad || 0 }}
                    </span>
                  </div>
                  <div v-else class="td td-stock">
                    <span style="color: #10b981; font-weight: bold">-</span>
                  </div>
                  <div class="td td-precio">
                    Bs
                    <span style="font-weight: bold; color: #dc2626">
                      {{
                        slotProps.item.stock[0]?.ultimo_precio ||
                        slotProps.item.precio_sugerido
                      }}
                    </span>
                  </div>
                </div>
              </template>
            </AutoComplete>

            <Button
              :disabled="!productoSelecionado || cargandoProductos"
              :icon="
                cargandoProductos ? 'pi pi-spin pi-spinner' : 'pi pi-search'
              "
              class="p-button-warning"
              v-tooltip.top="'Buscar'"
              @click="buscarProducto($event)"
            />
            <Button
              icon="pi pi-bars"
              class="p-button-info"
              v-tooltip.top="'Ver Resultados'"
              :disabled="productosListadoFiltrado.length == 0"
              @click="activarModalProductosFiltrados"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <DataTable
        :value="productos"
        class="p-datatable-sm"
        responsiveLayout="scroll"
        showGridlines
        editMode="cell"
        @cell-edit-complete="guardandoCambiosCelda"
        :rowHover="true"
      >
        <template #empty>
          <span
            class="flex align-items-center justify-content-center p-invalid"
          >
            Busca productos para agregar al detalle!
          </span>
        </template>

        <Column header="#">
          <template #body="slotProps">
            {{ 1 + slotProps.index }}
          </template>
        </Column>

        <Column header="CÓDIGO" v-if="mostrar_codigo_interno">
          <template #body="{ data }">
            {{ data.codigo_interno }}
          </template>
        </Column>

        <Column field="descripcion" header="DESCRIPCIÓN/PRODUCTO">
          <template #body="{ data }">
            <strong>{{ data.descripcion }}</strong>
            <span v-if="data.fabrica_nombre">
              ** {{ data.fabrica_nombre }}</span
            >
          </template>
        </Column>

        <Column
          field="cantidad"
          header="CANTIDAD"
          class="bg-green-200"
          style="font-weight: bold; color: black"
        >
          <template #body="{ data }">
            {{ data.cantidad }}
          </template>
          <template #editor="{ data, field }">
            <InputNumber v-model="data[field]" :min="1" />
          </template>
        </Column>

        <Column field="precio" header="PRECIO">
          <template #body="{ data }">
            {{ convertirNumeroGermanicFormat(data.precio) }}
          </template>
          <template #editor="{ data, field }">
            <InputNumber
              v-model="data[field]"
              :minFractionDigits="2"
              :maxFractionDigits="2"
              :min="0"
              locale="de-DE"
            />
          </template>
        </Column>

        <!-- NUEVA COLUMNA DESCUENTO -->
        <Column field="descuento_neto" header="DESC.">
          <template #body="{ data }">
            <span
              :style="
                data.descuento_neto > 0 ? 'color: #dc2626; font-weight: bold;' : ''
              "
            >
              {{ convertirNumeroGermanicFormat(data.descuento_neto || 0) }}
            </span>
          </template>
          <template #editor="{ data, field }">
            <InputNumber
              v-model="data[field]"
              :minFractionDigits="2"
              :maxFractionDigits="2"
              :min="0"
              locale="de-DE"
            />
          </template>
        </Column>

        <Column header="TOTAL" class="text-right">
          <template #body="{ data }">
            {{
              convertirNumeroGermanicFormat(
                data.cantidad * data.precio - (data.descuento_neto || 0),
              )
            }}
          </template>
        </Column>

        <Column
          v-if="medico_referencia"
          field="medico_id"
          header="TRABAJADOR/A"
        >
          <template #body="{ data }">
            {{ data.nombre_medico || "" }}
          </template>
          <template #editor="{ data }">
            <Dropdown
              v-model="data.medico_id"
              :options="medicos"
              optionLabel="nombre_completo"
              optionValue="id"
              placeholder="Seleccione..."
              @change="onMedicoChange($event, data)"
            />
          </template>
        </Column>

        <Column>
          <template #header>
            <i class="pi pi-trash"></i>
          </template>
          <template #body="slotProps">
            <Button
              @click="quitarProductoDetalle(slotProps)"
              v-tooltip.top="'Quitar Producto'"
              icon="pi pi-times"
              class="p-button-rounded p-button-danger p-button-text"
            />
          </template>
        </Column>
      </DataTable>

      <!-- Totales MODIFICADO -->
      <div class="mt-3">
        <div class="flex justify-content-end">
          <div style="min-width: 300px">
            <div
              class="flex justify-content-between p-2 border-bottom-1 border-300"
            >
              <span class="font-semibold">SUBTOTAL:</span>
              <span>{{ convertirNumeroGermanicFormat(subtotal) }} Bs.</span>
            </div>
            <div
              class="flex justify-content-between p-2 border-bottom-1 border-300"
            >
              <span class="font-semibold">DESCUENTO:</span>
              <span style="color: #dc2626; font-weight: bold">
                - {{ convertirNumeroGermanicFormat(descuentoTotal) }} Bs.
              </span>
            </div>
            <div
              class="flex justify-content-between p-3 bg-blue-50 border-round"
            >
              <h2 class="m-0">TOTAL:</h2>
              <h2 class="m-0">
                <span style="color: #dc2626"
                  >{{ convertirNumeroGermanicFormat(total) }} Bs.</span
                >
              </h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ProducoListadoModal
    v-if="productosResultados"
    @closeModal="cerrarModalProductoResultados"
    :show="productosResultados"
    :productos="productosFiltrados"
    :mostrar_cif="false"
    @agregarProductos="agregarProductos"
  />
</template>

<script>
import VentaService from "@/service/VentaService";
import ProductService from "@/service/ProductService";
import MedicoService from "@/service/MedicoService";
import ProducoListadoModal from "@/module/productos/ProductoListadoModal.vue";
import { debounce } from "@/helpers/debounce";

export default {
  components: {
    ProducoListadoModal,
  },
  data() {
    return {
      proforma_id: null,
      clienteNombre: "",
      placa: "",
      tipo_negocio: 1,
      productos: [],
      productoSelecionado: null,
      productosListadoFiltrado: [],
      productosResultados: false,
      productosFiltrados: [],
      guardando: false,
      medicos: [],
      medico_referencia: false,
      sucursal_id: null,
      medico_id: null,
      nombre_medico: null,
      cargandoProductos: false,
      mostrar_codigo_interno: false,
      buscar_sin_enter: false,
      cacheBusquedaProducto: new Map(),
      abortController: null,
      stockClass: (cantidad) => {
        if (cantidad <= 0) return "outofstock";
        else if (cantidad <= 10) return "lowstock";
        else return "instock";
      },
    };
  },
  ventaService: null,
  productService: null,
  medicoService: null,
  created() {
    this.ventaService = new VentaService();
    this.productService = new ProductService();
    this.medicoService = new MedicoService();
    this.proforma_id = this.$route.params.id;

    this.buscarProductoDebounced = debounce(this.buscarProductoImpl, 400);
  },
  mounted() {
    this.cargarProforma();
    this.cargarMedicos();
  },
  computed: {
    // MODIFICADO
    subtotal() {
      return this.productos.reduce((sum, p) => sum + p.cantidad * p.precio, 0);
    },
    // NUEVO
    descuentoTotal() {
      return this.productos.reduce((sum, p) => sum + (p.descuento_neto || 0), 0);
    },
    // MODIFICADO
    total() {
      return this.subtotal - this.descuentoTotal;
    },
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    convertirNumeroGermanicFormat(numero) {
      return new Intl.NumberFormat("de-DE", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(numero);
    },

    async cargarProforma() {
      try {
        const response = await this.ventaService.getProforma(this.proforma_id);

        if (response.success) {
          const proforma = response.proforma;

          this.clienteNombre = proforma.cliente;
          this.placa = proforma.placa_vehiculo;
          this.tipo_negocio = proforma.tipo_negocio;
          this.sucursal_id = proforma.sucursal_id;
          this.medico_id = proforma.medico_id;
          this.nombre_medico = proforma.nombre_medico;

          if (this.medico_id) {
            this.medico_referencia = true;
          }

          this.productos = proforma.detalles.map((det) => ({
            producto_id: det.pivot.producto_id,
            descripcion: det.descripcion,
            codigo_interno: det.codigo_interno || "",
            fabrica_nombre: det.fabrica_nombre || "",
            cantidad: parseFloat(det.pivot.cantidad),
            precio: parseFloat(det.pivot.precio),
            descuento_neto: parseFloat(det.pivot.descuento_neto || 0), // AGREGADO
            lote: det.pivot.lote,
            fecha_vence: det.pivot.fecha_vence,
            medico_id: det.pivot.medico_id || proforma.medico_id,
            nombre_medico: det.pivot.nombre_medico || proforma.nombre_medico,
            es_comisionable: det.es_comisionable || 0,
            comision_medico: det.comision_medico || 0,
          }));
        }
      } catch (error) {
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: "No se pudo cargar la proforma",
          life: 3000,
        });
      }
    },

    async cargarMedicos() {
      const response = await this.medicoService.getMedicosAll();
      this.medicos = response.medicos || [];
    },

    buscarProducto(event) {
      const texto =
        typeof this.productoSelecionado === "string"
          ? this.productoSelecionado.trim()
          : this.productoSelecionado?.descripcion || "";

      if (!texto || texto.length < 2) {
        this.productosListadoFiltrado = [];
        return;
      }

      const cacheKey = `producto_${texto.toLowerCase()}`;

      const esBusquedaDirecta =
        (event?.type === "keyup" && event?.key === "Enter") ||
        event?.type === "click";

      if (esBusquedaDirecta) {
        if (this.buscarProductoDebounced?.cancel) {
          this.buscarProductoDebounced.cancel();
        }
        this.cacheBusquedaProducto.delete(cacheKey);
        this.buscarProductoImpl(texto, cacheKey);
        return;
      }

      if (this.buscar_sin_enter && this.cacheBusquedaProducto.has(cacheKey)) {
        this.productosListadoFiltrado =
          this.cacheBusquedaProducto.get(cacheKey);
        return;
      }

      if (!this.buscar_sin_enter) return;

      this.buscarProductoDebounced(texto, cacheKey);
    },

    manejadorBusquedaProducto(event) {
      if (this.buscar_sin_enter) {
        if (event?.type !== "keyup" || event?.key !== "Enter") {
          this.buscarProducto(event);
        }
      }
    },

    async buscarProductoImpl(texto, cacheKey) {
      if (this.abortController) {
        this.abortController.abort();
      }

      if (this.cargandoProductos) return;

      this.abortController = new AbortController();
      this.cargandoProductos = true;

      try {
        const response = await this.productService.buscarProductosOptimizado(
          {
            texto: texto,
            buscarProductoPorSelected: ["nombre_comercial"],
            sucursal_id: this.sucursal_id,
            limite_busqueda_productos: 50,
          },
          {
            signal: this.abortController.signal,
          },
        );

        if (response.productos?.length > 0) {
          this.productosListadoFiltrado = response.productos;
          this.cacheBusquedaProducto.set(
            cacheKey,
            this.productosListadoFiltrado,
          );

          if (this.cacheBusquedaProducto.size > 50) {
            const firstKey = this.cacheBusquedaProducto.keys().next().value;
            this.cacheBusquedaProducto.delete(firstKey);
          }
        } else {
          this.productosListadoFiltrado = [];
        }
      } catch (error) {
        if (error.name !== "AbortError") {
          this.productosListadoFiltrado = [];
        }
      } finally {
        this.cargandoProductos = false;
        this.abortController = null;
      }
    },

    activarModalProductosFiltrados() {
      this.productosResultados = true;
      this.productosFiltrados = this.productosListadoFiltrado;
    },

    cerrarModalProductoResultados() {
      this.productosResultados = false;
    },

    agregarProductos(productosSeleccionados) {
      productosSeleccionados.forEach((producto) => {
        this.agregarDetalleVenta(producto);
      });
      this.cerrarModalProductoResultados();
    },

    agregarDetalleVenta(data) {
      const existe = this.productos.find((p) => p.producto_id == data.id);

      if (existe) {
        existe.cantidad += 1;
        return;
      }

      let precio = data.stock[0]?.ultimo_precio || data.precio_sugerido || 0;

      this.productos.push({
        producto_id: data.id,
        descripcion: data.descripcion,
        codigo_interno: data.codigo_interno || "",
        fabrica_nombre: data.fabrica_nombre || data.fabricas?.nombre || "",
        cantidad: 1,
        precio: parseFloat(precio),
        descuento_neto: 0, // AGREGADO
        lote: data.stock[0]?.lote || null,
        fecha_vence: data.stock[0]?.fecha_vence || null,
        medico_id: this.medico_id,
        nombre_medico: this.nombre_medico,
        es_comisionable: data.stock[0]?.es_comisionable || 0,
        comision_medico: data.stock[0]?.comision_medico || 0,
      });

      this.productosListadoFiltrado = [];
      this.productoSelecionado = null;
    },

    guardandoCambiosCelda(e) {
      let { data, newValue, field } = e;
      data[field] = newValue;

      if (field == "medico_id") {
        const medico = this.medicos.find((med) => med.id === newValue);
        data.nombre_medico = medico?.nombre_completo || null;
      }
    },

    onMedicoChange(event, data) {
      const medico = this.medicos.find((m) => m.id === event.value);
      data.nombre_medico = medico?.nombre_completo || null;
    },

    quitarProductoDetalle(datos) {
      this.$confirm.require({
        header: "Confirmación",
        icon: "pi pi-exclamation-triangle",
        message: "¿ESTÁS SEGURO DE ELIMINAR EL PRODUCTO?",
        acceptLabel: "Si, Eliminar",
        rejectLabel: "No, Cancelar",
        accept: () => {
          this.productos.splice(datos.index, 1);
        },
      });
    },

    async guardarCambios() {
      if (this.productos.length === 0) {
        this.$toast.add({
          severity: "warn",
          summary: "Advertencia",
          detail: "Debe tener al menos un producto",
          life: 3000,
        });
        return;
      }

      this.guardando = true;

      try {
        const response = await this.ventaService.actualizarProforma({
          proforma_id: this.proforma_id,
          productos: this.productos,
          total: this.total,
          medico_id: this.medico_id,
          nombre_medico: this.nombre_medico,
        });

        if (response.status === 200) {
          this.$toast.add({
            severity: "success",
            summary: "Éxito",
            detail: "Proforma actualizada correctamente",
            life: 3000,
          });
        }
      } catch (error) {
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: "No se pudo guardar los cambios",
          life: 3000,
        });
      } finally {
        this.guardando = false;
      }
    },

    convertirAVenta() {
      this.$router.push({
        name: "nueva_venta",
        query: { proforma_id: this.proforma_id },
      });
    },
  },
  watch: {
    productoSelecionado(newVal) {
      if (newVal?.id) {
        this.agregarDetalleVenta(newVal);
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/demo/badges.scss";

.tabla-header {
  display: flex;
  align-items: center;
  padding: 4px 6px;
  background: #002236;
  color: white;
  font-weight: 700;
  font-size: 0.75rem;
}

.th {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 4px;
}

.th-producto {
  flex: 1;
  justify-content: flex-start;
}

.th-fabrica {
  width: 120px;
}

.th-stock {
  width: 60px;
}

.th-precio {
  width: 80px;
}

.tabla-fila {
  display: flex;
  align-items: center;
  padding: 4px 6px;
  cursor: pointer;
}

.tabla-fila:hover {
  background: #eff6ff;
}

.td {
  display: flex;
  align-items: center;
  padding: 0 4px;
}

.td-producto {
  flex: 1;
  font-weight: 600;
}

.td-fabrica {
  width: 120px;
  font-weight: 600;
  color: #4b5563;
}

.td-stock {
  width: 60px;
  font-weight: 700;
  justify-content: center;
}

.td-precio {
  width: 80px;
  justify-content: center;
}

.outofstock {
  font-weight: 700;
  color: #ffffff;
  background-color: #747474;
  padding: 2px 8px;
  border-radius: 4px;
}

.lowstock {
  font-weight: 700;
  color: #000000;
  background-color: #fbc02d;
  padding: 2px 8px;
  border-radius: 4px;
}

.instock {
  font-weight: 700;
  color: #000000;
  background-color: #7bffae;
  padding: 2px 8px;
  border-radius: 4px;
}
</style>
